import * as React from "react";
const defaultContext = {
  log: (message) => console.error(message)
};
const ErrorContext = React.createContext(defaultContext);
const ErrorProvider = (props) => {
  const { onError, children } = props;
  const log = React.useCallback(
    (message) => {
      console.error(message);
      onError(message);
    },
    [onError]
  );
  const contextValue = React.useMemo(() => ({ log }), [log]);
  return /* @__PURE__ */ React.createElement(ErrorContext.Provider, { value: contextValue }, children);
};
export {
  ErrorContext,
  ErrorProvider,
  defaultContext
};
